'use client'

import { useEffect, useState } from 'react'
import { ArrowDownIcon, ListIcon, ListOrderedIcon } from 'lucide-react'
import { useEditorContext } from '@/components/ui/editor'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

const List = () => {
  const { editor, sourceMode } = useEditorContext()

  const [selectionStates, setSelectionStates] = useState({
    bulletList: false,
    orderedList: false
  })

  useEffect(() => {
    if (!editor) {
      return
    }

    const updateSelection = () => {
      setSelectionStates({
        bulletList: editor.isActive('bulletList'),
        orderedList: editor.isActive('orderedList')
      })
    }

    editor.on('selectionUpdate', updateSelection)
    editor.on('transaction', updateSelection)

    // cleanup
    return () => {
      editor.off('selectionUpdate', updateSelection)
      editor.off('transaction', updateSelection)
    }
  }, [editor])

  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <DropdownMenuTrigger asChild>
              <Button type="button" size="sm" variant="ghost" disabled={sourceMode} tabIndex={-1}>
                <ListOrderedIcon />
                <ArrowDownIcon />
              </Button>
            </DropdownMenuTrigger>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>List</p>
        </TooltipContent>
      </Tooltip>
      <DropdownMenuContent align="start">
        <DropdownMenuItem
          className={selectionStates.bulletList ? 'bg-gray-100 dark:bg-gray-800' : ''}
          onClick={() => editor.chain().focus().toggleBulletList().run()}>
          <ListIcon />
          <span>Bullet List</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className={selectionStates.orderedList ? 'bg-gray-100 dark:bg-gray-800' : ''}
          onClick={() => editor.chain().focus().toggleOrderedList().run()}>
          <ListOrderedIcon />
          <span>Numbered List</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default List
